import React, { useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectTasksCountStat } from 'mt-react-common/modules/users/common/reducers/states/authAccount';
import { t } from 'utils/translates';

const EarnMoneyNav = props => {
  useEffect(() => {
    // eslint-disable-next-line no-undef
    $(`#panelGroupMenu_c_2`).collapse(props.isOpen ? 'show' : 'hide');
  }, [props.isOpen]);

  return (
    <div className="panel panel-default">
      <div className="panel-heading" role="tab" id="panelGroupMenu_h_2">
        <a
          className="dropdown-toggle dropdown-toggle-collapse collapsed"
          role="button"
          data-toggle="collapse"
          data-parent="#panelGroupMenu"
          href={null}
          aria-expanded="false"
          aria-controls="panelGroupMenu_c_2"
          title={t('Биржа заданий')}
          onClick={props.onToggle}
        >
          <i className="fa fa-money fa-lg fa-fw" aria-hidden="true" />{' '}
          {t('Биржа заданий')}
        </a>
      </div>
      <div
        id="panelGroupMenu_c_2"
        className="panel-collapse collapse"
        role="tabpanel"
        aria-labelledby="panelGroupMenu_h_2"
      >
        <div className="list-group">
          <NavLink
            to="/earn-money/new-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('Новые задания')}
          >
            <span className="badge">{props.countsTasksStat.countNewTasks}</span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('Новые задания')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/in-process-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('В процессе выполнения')}
          >
            <span className="badge">
              {props.countsTasksStat.myExecutionsStat.countExecProcessed}
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('В процессе выполнения')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/checked-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('На проверке')}
          >
            <span className="badge">
              {props.countsTasksStat.myExecutionsStat.countExecAtCheckout}
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('На проверке')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/remake-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('Доработать')}
          >
            <span className="badge">
              {props.countsTasksStat.myExecutionsStat.countExecRemake}
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('Доработать')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/finished-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('Завершенные')}
          >
            <span className="badge">
              {props.countsTasksStat.myExecutionsStat.countExecFinished}
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('Завершенные')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/canceled-by-owner-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('Отказано заказчиками')}
          >
            <span className="badge">
              {
                props.countsTasksStat.myExecutionsStat
                  .countExecCanceledByTaskOwner
              }
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('Отказано заказчиками')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/not-done-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('Невыполненные')}
          >
            <span className="badge">
              {props.countsTasksStat.myExecutionsStat.countExecNotDone}
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('Невыполненные')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/arbitration-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('Арбитраж')}
          >
            <span className="badge">
              {props.countsTasksStat.myExecutionsStat.countExecDispute}
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('Арбитраж')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/chosen-tasks"
            activeClassName="active"
            className="list-group-item border-t border-dashed"
            title={t('Избранные')}
          >
            <span className="badge">
              {props.countsTasksStat.countTasksChosen}
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('Избранные')}
            </span>
          </NavLink>
          <NavLink
            to="/earn-money/hidden-tasks"
            activeClassName="active"
            className="list-group-item"
            title={t('Скрытые')}
          >
            <span className="badge">
              {props.countsTasksStat.countTasksHide}
            </span>{' '}
            <span className="list-group-item-val text-overflow">
              {t('Скрытые')}
            </span>
          </NavLink>
        </div>
      </div>
    </div>
  );
};

EarnMoneyNav.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  countsTasksStat: PropTypes.shape({
    countNewTasks: PropTypes.number.isRequired,
    countTasksChosen: PropTypes.number.isRequired,
    countTasksHide: PropTypes.number.isRequired,
    myExecutionsStat: PropTypes.shape({
      countExecProcessed: PropTypes.number.isRequired,
      countExecAtCheckout: PropTypes.number.isRequired,
      countExecRemake: PropTypes.number.isRequired,
      countExecFinished: PropTypes.number.isRequired,
      countExecDispute: PropTypes.number.isRequired,
      countExecCanceledByTaskOwner: PropTypes.number.isRequired,
      countExecNotDone: PropTypes.number.isRequired
    })
  }).isRequired
};

EarnMoneyNav.defaultProps = {
  isOpen: false,
  onToggle: () => {}
};

const mapStateToProps = state => ({
  countsTasksStat: selectTasksCountStat(state)
});

export default withRouter(connect(mapStateToProps)(EarnMoneyNav));



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Sidebar/Navs/EarnMoneyNav.js